export const Expense = {
    path: '/expenses',
    name: 'expenses',
    component: () => import('@/views/Expense/ExpensePage.vue'),
    children: [
        {
            path: '/expenses/add',
            name: 'expenses.add',
            component: () => import('@/views/Expense/Form/ExpenseForm.vue'),
            props: {addAction: true},
        },
        {
            path: '/expenses/edit/:id',
            name: 'expenses.edit',
            component: () => import('@/views/Expense/Form/ExpenseForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/expenses/delete/:id',
            name: 'expenses.delete',
            component: () => import('@/views/Expense/Form/ExpenseForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/expenses/view/:id',
            name: 'expenses.view',
            component: () => import('@/views/Expense/Form/ExpenseForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/expenses/validate/:id',
            name: 'expenses.validate',
            component: () => import('@/views/Expense/Form/ExpenseForm.vue'),
            props: {validateAction: true}
        },
    ]
}